import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  tableOverflow: {
    overflow: 'auto'
  },
  tableWidget: {
    overflowX: "auto",
  },
  input: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    padding: '12px',
    width: '350px',
    outlineColor: "#FFFFFF"
  },
  divHeader: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    marginBottom: '24px',
  },
  div: {
    height: '50px',
    width: '410px',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widget,
  },
  divSearch: {
    height: '50px',
    width: '53px',
    padding: '2px',
    backgroundColor: "#FFFFFF",
  },
  divAddButton: {
    height: '50px',
    width: '50px',
    backgroundColor: "#FFFFFF",
    marginLeft: '24px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  searchIcon: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  divTitle: {
    width: "100%",
    display: "flex",
    marginTop: "12px",
    marginLeft: "12px",
    marginBottom: "24px",
  },
  titleStyle: {
    fontWeight: '500',
    fontSize: "28px",
    color: "#999696",
  },
  divSeparate: {
    marginBottom: "50px"
  },
  green: {
    backgroundColor: theme.palette.green.main,
    color: '#fff',
  },
  yellow: {
    backgroundColor: theme.palette.yellow.main,
    color: '#fff',
  },
  gray: {
    backgroundColor: theme.palette.gray.main,
    color: '#fff',
  },
  red: {
    backgroundColor: theme.palette.red.main,
    color: '#fff',
  },
  divAddPage: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divButton: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "100px",
    marginBottom: "24px",
  },
  disableButton: {
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    borderWidth: "0px"
  },
  enableButton: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "20px",
    padding: "12px 40px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widget,
  },
  enableButtonSauna: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "16px",
    padding: "12px 40px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widget,
  },
  selectedButtonSauna: {
    backgroundColor: "#FF0000",
    color: "#FFFFFF",
    fontSize: "16px",
    padding: "12px 40px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widget,
  },
  divColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    ['@media (max-width:800px)']: {
      gridTemplateColumns: '1fr',
    },
    marginBottom: "24px",
  },
  inputText: {
    backgroundColor: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  textBorder: {
    "&:before": {
      borderBottomColor: '2px solid #F4F4F4'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
    },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000',
    },
  },
  label: {
    display: 'block',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#353434",
  },
  root: {
    display: 'block',
    flexWrap: 'wrap',
  },
  formControl: {
    width: '85%',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  loginLoader: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto"
  },
  textFieldTime: {
    width: '70%',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    marginBottom: "24px",
  },
  indeterminateColor: {
    color: "#f50057"
  },
  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  },
  footerTable: {
    display: "flex",
    float: "right",
    marginTop: "12px",
    marginBottom: "12px",
    marginRight: "24px",
  },
  footerText: {
    fontSize: "13px",
    color: "#000000",
    marginRight: "24px",
  },
  spaceBetweenButtons:{
    marginRight: "20px",
  },
  buttonPageEnable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    cursor: "pointer",
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  buttonPageDisable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  cancelButton: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#FF0000",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    color: "#FF0000",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
    marginBottom: "16px",
  },
  addButton: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#3CD4A0",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    color: "#3CD4A0",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
    marginBottom: "16px",
  },
  cancelButtonDisable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    color: "#EBEBEB",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
    marginBottom: "16px",
  },
  addButtonDisable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    color: "#EBEBEB",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
    marginBottom: "16px",
  },
  rowButtons: {
    display: 'flex',
    float: "right",
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  divSwitch: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
  },
}));
